import React from "react";

import background from '@cover/motorstarten/background-1.svg';
import MotorStarten from "../components/cover/animations/motorstarten";

export const meta = {
	category: "start",
	slug: "motorstarten",
	id: "MotorStarten",
	name: "motorstarten",
	excerpt: {
		before: "Eine Übung für den perfekten Start in den Tag"
	},
	title: "Workout",
	animation: MotorStarten,
	cover: {
		background: {
			lg: background,
			sm: background
		},
		alt: "Ein Mädchen meditiert. Sie ist umgeben von einem Elektroauto, einem Fahrrad und zwei ebenso entspannten Personen, die rollerskaten und windgleiten."
	}
}

const MotorstartenArticle = () => {
	return (
		<div>
			<p className="articleStatement">
				für den perfekten Start in den Tag:
			</p>
			<ul className="articleList">
				<li className="articleListItem">Schultern kreisen: 5 bis 8 Mal</li>
				<li className="articleListItem">Katzenbuckel vs. Hohlkreuz: 10 Mal</li>
				<li className="articleListItem">Hocke: 5-8 Mal</li>
				<li className="articleListItem">Ausfallschritte: 10 Mal pro Bein</li>
				<li className="articleListItem">Unterarmstütz: 1 bis 5 Mal, so lange wie möglich halten</li>
				<li className="articleListItem">Hampelmann: 20 Mal</li>
				<li className="articleListItem">Jogging: 60 Sekunden</li>
			</ul>
		</div>
	)
};

export default MotorstartenArticle;
